export default function MotifRefusAdmissionConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('motifs.refus.admission');
}

MotifRefusAdmissionConfiguration.$inject = ['$translatePartialLoaderProvider'];
